import React from 'react'
import { Link } from 'gatsby'
import { FaBars, FaTimes, FaRegEnvelope } from 'react-icons/fa'
import './Header.scss'
import HeaderSolutionsMenu from '../HeaderSolutionsMenu/HeaderSolutionsMenu'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showSolutionsMenu: false,
      mobileMenu: false,
      isScrolled: false,
    }
    this.initClutch()
  }

  componentDidMount() {
    this.initClutch()
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const isScrolled = scrollTop > 0

    if (this.state.isScrolled !== isScrolled) {
      this.setState({ isScrolled })
    }
  }

  initClutch() {
    setTimeout(() => {
      if (
        typeof document !== 'undefined' &&
        typeof window !== 'undefined' &&
        typeof window.CLUTCHCO !== 'undefined'
      ) {
        window.CLUTCHCO.Init()
      }
    }, 200)
  }

  handleHoverSolutions = event => {
    this.setState({ showSolutionsMenu: true })
  }

  handleLeaveSolutions = event => {
    this.setState({ showSolutionsMenu: false })
  }

  toggleMenu() {
    this.setState({
      mobileMenu: !this.state.mobileMenu,
    })
  }

  render() {
    const headerClasses = []
    if (!this.state.mobileMenu && this.props.type) {
      headerClasses.push(this.props.type)
    }
    if (this.state.isScrolled) {
      headerClasses.push('scrolled')
    }

    return (
      <header className={headerClasses.join(' ')}>
        <nav>
          <Link to="/">
            <div className="logo-wrap">
              {this.props.type &&
              !this.state.mobileMenu &&
              this.props.type === 'clear' &&
              !this.state.isScrolled ? (
                <img src="/logos/RacknerLogoWhite.png" />
              ) : (
                <img src="/logos/RacknerLogo.png" />
              )}
            </div>
          </Link>
          <div className="buffer" />
          <div className="stacked-nav">
            <div className="super-nav">
              <ul>
                <li>
                  <a href="https://boards.greenhouse.io/rackner">Careers</a>
                </li>
                <li>
                  <Link to="/training">Training</Link>
                </li>
                <li>
                  <Link to="/contractvehicles">Contracts</Link>
                </li>
                <Link to="/contact">
                  <li className="contact-button">
                    <FaRegEnvelope />
                    Contact
                  </li>
                </Link>
              </ul>
            </div>
            <div className="base-nav">
              <ul>
                <li onMouseLeave={this.handleLeaveSolutions.bind(this)}>
                  <a
                    href="#"
                    onMouseEnter={this.handleHoverSolutions.bind(this)}
                  >
                    Solutions
                  </a>
                  <div className="submenu-container">
                    {this.state.showSolutionsMenu && <HeaderSolutionsMenu />}
                  </div>
                </li>
                <li>
                  <Link to="/insights/">Insights</Link>
                </li>
                <li>
                  <Link to="/about/">About</Link>
                </li>
              </ul>
            </div>
          </div>
          <div
            onClick={this.toggleMenu.bind(this)}
            className="mobile-menu-button"
          >
            {this.state.mobileMenu ? <FaTimes /> : <FaBars />}
          </div>
          <div
            className={
              'mobile-menu-dropdown ' + (this.state.mobileMenu ? 'active' : '')
            }
          >
            <ul>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <a href="/reaper">REAPER</a>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <a href="/code-falcon">Code Falcon</a>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <a href="/bifrost">Bifrost</a>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <Link to="/covalent/">Enclave AI</Link>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <Link to="/kubernetes/">Kubernetes</Link>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <Link to="/boost/">Boost</Link>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <Link to="/insights/">Insights</Link>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <Link to="/about/">About</Link>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <a href="https://boards.greenhouse.io/rackner">Careers</a>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <Link to="/contractvehicles">Contract Vehicles</Link>
              </li>
              <li
                onClick={this.toggleMenu.bind(this)}
                className={this.state.mobileMenu ? 'active' : ''}
              >
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    )
  }
}

export default Header
